export const DEFAULT_STORY_AUTHOR = "AirHelp";
